module.exports = __webpack_public_path__ + "static/media/iconProjetEducatifActive.eeef8e91.svg";